import React from 'react';
import { TouchableOpacity, Text, StyleSheet, Alert, Platform } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { processLoginAccount } from '../utils/Functions';
import UserState from '../src/contexts/UserState';
import Storage from './Storage';
import { useLinkTo } from '@react-navigation/native';
import * as WebBrowser from 'expo-web-browser';
import * as Facebook from 'expo-auth-session/providers/facebook';
import { ResponseType } from 'expo-auth-session';

export default function FacebookAuthButton(props) {
  const [user, setUser] = React.useContext(UserState);
  const linkTo = useLinkTo();

  const [request, response, promptAsync] = Facebook.useAuthRequest({
    expoClientId: '274664500583841',
    iosClientId: '274664500583841',
    androidClientId: '274664500583841',
    webClientId: '274664500583841',
    // responseType: ResponseType.Code,
  });

  const facebookIcon = <FontAwesome name="facebook" size={16} color="white" />;

  React.useEffect(() => {
    if (Platform.OS === 'android') {
      WebBrowser.warmUpAsync();
      return () => {
        WebBrowser.coolDownAsync();
      };
    }
  }, []);

  React.useEffect(() => {
    console.log('useEffect response: ', response);
    if (response?.type === 'success') {
      // const { code } = response.params;
      const { access_token } = response.params;
      // console.log('code: ', code);
      console.log('access_token: ', access_token);
      getFacebookUserInfo(access_token);
    }
  }, [response]);

  const getFacebookUserInfo = async (token) => {
    fetch(`https://graph.facebook.com/me?fields=id,name,email,picture.width(720).height(720),address&access_token=${token}`)
      .then(resp => resp.json())
      .then(user => {
        console.log('getFacebookUserInfo: ', user);
        loginWithFacebook(user, token);
      })
  }

  // const appsecretProof = '';

  const loginWithFacebook = async (user, token) => {
    // alert('FB Login');
    try {
      if (props.setLoginType) {
        props.setLoginType('Facebook');
      }
      
      console.log('user', user);
      console.log('token', token);
      let fbUser = {
        email: user.email,
        name: user.name,
        avatar: user.picture.data.url,
        type: 'Facebook',
        id: user.id,
        token: token,
      };
      props.setSocialUser(fbUser);
      console.log('fbUser', fbUser);
      try {
        let apiLoginResult = await props.socialApiLogin(fbUser, 'facebook');
        // let apiLoginResult = await props.socialApiLogin('facebook');
        console.log('apiLoginResult', apiLoginResult);
        if (apiLoginResult.result) {
          let u = processLoginAccount(apiLoginResult.session.account, true);
          checkUsernameSecureStore(u, fbUser);
          // props.setUser(user);
          // props.setLoggedIn(true);
        } else {
          console.log('else');
          if (apiLoginResult.MFA) {
            props.setShowMFA(true);
            props.setMFARequired(true);
          } else {
            console.log('else2');
            if (apiLoginResult.errors) {
              console.log(apiLoginResult.errors.join('; '));
            }
            console.log('else3');
            // console.log('should navigate to signup...', fbUser, `/signup/emailpassword?socialUser=${encodeURIComponent(JSON.stringify(fbUSer))}`);
            console.log('should navigate to signup...');
            console.log('else4');
            // props.navigation.navigate('SignUp', { fbUser: fbUser });
            // linkTo(`/signup/emailpassword/${encodeURIComponent(JSON.stringify(fbUSer))}`);
            // linkTo('/signup/emailpassword?socialUser=chad')
            // props.navigation.navigate('SignUp', { fbUser: fbUser });
            props.navigation.navigate('SignUp', { socialUser: fbUser });
            console.log('else5');
          }
        }
      } catch (err) {
        Alert.alert('Error', err);
      }
    } catch ({ message }) {
      alert(`Facebook Login Error: ${message}`);
    }
  }

  const checkUsernameSecureStore = async (u, socialUser) => {
    // const delU = SecureStore.deleteItemAsync('username');
    // const delP = SecureStore.deleteItemAsync('password');
    // const setA = SecureStore.setItemAsync('useLocalAuthentication', 'no');
    const socialId = await Storage.getItem('socialId');
    console.log('checkUsernameSecureStore', socialId);
    if (!socialId || (socialId !== socialUser.id)) {
      console.log('deleting useLocalAuthentication');
      await Storage.removeItem('useLocalAuthentication');
    }

    console.log('social checkUserNameSecureStore: ', u, socialUser);
    const setS = Storage.setItem('socialId', socialUser.id);
    const delU = Storage.removeItem('username');
    const delP = Storage.removeItem('password');
    await Promise.all([setS, delU, delP])

    console.log('setting user facebook', user, u);
    setUser(u);
    console.log('setting user facebook 2', user);

    if (!u.terms_of_use) {
      linkTo('/acceptterms?signUp=yes');
    }

    return true;
  }

  return (
    <TouchableOpacity style={styles.button} onPress={() => promptAsync()} activeOpacity={0.6}>
      <FontAwesome name="facebook" size={16} color="white" />
      <Text style={styles.text}>Sign in with Facebook</Text>
    </TouchableOpacity>
  );

}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    padding: 10,
    backgroundColor: '#3b5998'
  },
  text: {
    color: 'white',
    marginLeft: 5,
    fontSize: 18,
    fontWeight: '500',
  }
})